import { IFlowboxViewModel } from 'Scripts/Types/Litium';

import Markup from 'Components/Markup';

const Flowbox = ({
    flowDiv,
    text,
    textContainerMaxWidth,
    clauseText,
}: IFlowboxViewModel) => (
    <div>
        {text?.value && (
            <Markup
                html={text?.value}
                cssClass="lg:w-[var(--text-width)] mx-auto px-4 lg:px-0"
                style={
                    {
                        '--text-width': `${textContainerMaxWidth}%`,
                    } as React.CSSProperties
                }
            />
        )}
        {clauseText?.value && (
            <Markup
                html={clauseText?.value}
                cssClass="lg:w-[var(--text-width)] mx-auto px-4 lg:px-0"
                style={
                    {
                        '--text-width': `${textContainerMaxWidth}%`,
                    } as React.CSSProperties
                }
            />
        )}
        {flowDiv && <Markup html={flowDiv} />}
    </div>
);

export default Flowbox;
